export default "__VITE_ASSET__DV2iRy6z__"